<template>
  <a-card :bodyStyle="{height: `${tableHeight}px`, 'overflow-y': 'auto'}">
    <a-row :gutter="32">
      <a-col :span="4">
        <a-select placeholder="请选择动物品种"
                  v-model="queryParam.animalId"
                  allowClear
                  show-search
                  :filter-option="filterOption"
                  style="width: 100%">
          <a-select-option v-for="item in animalList" :key="item.id" :value="item.id">
            {{ item.code }}-{{ item.animalNickname }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4">
        <a-range-picker @change="onChange" />
      </a-col>
      <a-col :span="12">
        <a-select mode="multiple"
                  placeholder="请选择检查指标"
                  show-search
                  :filter-option="filterOption"
                  v-model="queryParam.code"
                  style="width: 100%">
          <a-select-option v-for="item in indexList" :key="item.id" :value="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2">
        <a-button type="primary" @click="search">查询</a-button>
      </a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <template v-for="(item, index) in chartList">
        <div :key="index" :id="item[0].checkItem" class="echart-box"></div>
      </template>
    </a-row>
  </a-card>
</template>

<script>
import { efcOcnMdAnimalList, efcOcnStandardMedicalOtherList, reportList } from '@api/online'
import * as echarts from 'echarts'

export default {
  name: 'reportCharts',
  data() {
    return {
      animalList: [],
      indexList: [],
      chartList: [],
      queryParam: {
        animalId: undefined,
        code: [],
        codes: '',
        startDate: '',
        endDate: ''
      },
      option: {}
    }
  },
  computed: {
    // 列表高度
    tableHeight() {
      return window.innerHeight - 194
    }
  },
  mounted() {
    this.getAnimal()
    this.getIndex()
  },
  methods: {
    setOption(xArr, yArr, title) {
      let yAxis = {
        type: 'value'
      }
      if(title.includes('体温')) {
        yAxis = {
          type: 'value',
          min: 25,
          max: 40,
          interval: 3
        }
      }
      return {
        title: {
          text: title,
          left: 'center'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xArr
        },
        yAxis,
        series: [
          {
            data: yArr,
            type: 'line',
            smooth: true
          }
        ]
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    initCharts(domId, option) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(domId))
      myChart.setOption(option)
    },
    onChange(e, dateArr) {
      this.queryParam.startDate = dateArr[ 0 ]
      this.queryParam.endDate = dateArr[ 1 ]
    },
    // 获取动物品种
    getAnimal() {
      efcOcnMdAnimalList().then(res => {
        this.animalList = res.result
      })
    },
    // 获取指标
    getIndex() {
      efcOcnStandardMedicalOtherList().then(res => {
        this.indexList = res.result
      })
    },
    search() {
      let params = {
        ...this.queryParam,
        codes: this.queryParam.code?.toString(),
        code: null
      }
      reportList(params).then(res => {
        this.chartList = res.result
        this.chartList?.forEach(ele => {
          let xData = []
          let yData = []
          ele.forEach(k => {
            xData.push(k.checkDate)
            yData.push(k.checkData)
          })
          let option = this.setOption(xData, yData, `${ele[ 0 ].checkName}（${ele[ 0 ].unit}）`)
          setTimeout(() => {
            this.initCharts(ele[ 0 ].checkItem, option)
          }, 1000)
        })
      })
    }
  }
}
</script>

<style scoped>
.echart-box {
  height: 300px;
}
</style>
